// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchBookList__section","content":"SearchBookList__content"};